<template>
	<div class="nav-sidebar-layout" @click="onNavSidebarLayoutClicked">
		<div :class="sidebarContainerClasses">
			<NavSidebarHOC />
		</div>
		<div :class="routeContainerClasses">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import NavSidebarHOC from "./NavSidebarHOC";

export default {
	name: "NavSidebarLayout",

	components: {
		NavSidebarHOC,
	},

	props: {
		showLeftSidebar: {
			type: Boolean,
			default: true,
		},
		scrollable: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		...mapGetters( "host-userProfile", [
			"userProfile",
			"isLoggedIn",
		] ),
		sidebarContainerClasses() {
			return {
				"nav-sidebar-layout__sidebar-container": true,
				"nav-sidebar-layout__sidebar-container--hidden": !this.showLeftSidebar,
			};
		},
		routeContainerClasses() {
			return {
				"nav-sidebar-layout__route-container": true,
				"nav-sidebar-layout__route-container--fullwidth": !this.showLeftSidebar,
				"nav-sidebar-layout__route-container--unscrollable": !this.scrollable,
			};
		},
	},

	methods: {
		...mapMutations( "host-layout", [ "closeNavSidebar", ] ),
		onNavSidebarLayoutClicked() {
			this.closeNavSidebar();
		},
	},
};
</script>

<style lang="scss">
.p-tooltip {
	// TODO: upgrade to version of primevue that allows custom tooltip attrs.
	z-index: 101;
}
.nav-sidebar-layout {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}

.nav-sidebar-layout__sidebar-container {
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;
	width: 0;
	z-index: 100;

	&--hidden {
		width: 0;
		display: none;
	}

	&:not(&--hidden) {
		@include for-size('md') {
			width: $nav-sidebar-tablet-width;
			display: block;
		}

		@include for-size('lg') {
			width: $nav-sidebar-width;
		}
	}
}

.nav-sidebar-layout__route-container {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;

	display: flex;
	flex-direction: column;

	&--fullwidth {
		left: 0;
	}

	&:not(&--fullwidth) {
		@include for-size('md') {
			left: $nav-sidebar-tablet-width;
		}

		@include for-size('lg') {
			left: $nav-sidebar-width;
		}
	}
}

.nav-sidebar-layout__route-container--unscrollable {
	overflow-y: hidden;
}
</style>
